// extracted by mini-css-extract-plugin
export default {"wrapper":"Summary_wrapper__PvmER"};